import React from 'react';
import { ReactiveList } from '@appbaseio/reactivesearch';

import { Row, Col, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import VerticalCard from './VerticalCard';
import HorizontalCard from './HorizontalCard';

/*
	This component is used to generate Results via ReactiveList.
	For smaller screen we use HorizontalCard to generate a List
	layout whereas for large screen we use VerticalCard to generate
	Card Layout.

	You can override the default props by using reactiveListProps at L28.
*/

const BookList = props => {
	const { title, reactiveListProps } = props;
	return (
		<React.Fragment>
			{title && <h2>{title}</h2>}
			<ReactiveList
				componentId="result"
				dataField="original_title.raw"
				size={4}
				scrollOnChange={false}
				loader={<Skeleton active />}
				pagination
				{...reactiveListProps}
				render={({ data }) => (
					<Row style={{ marginBottom: 80 }} gutter={{ xs: 8, sm: 16, md: 24 }}>
						{window.screen.availWidth < 576 ? (
							<HorizontalCard results={data} />
						) : (
							data.map(item => (
								<Link to={`/book/${item._id}`} key={item._id}>
									<Col
										span={6}
										xl={6}
										lg={8}
										md={12}
										sm={24}
										xs={24}
										{...props.responsiveCards}
									>
										<VerticalCard {...props} item={item} />
									</Col>
								</Link>
							))
						)}
					</Row>
				)}
			/>
		</React.Fragment>
	);
};

export default BookList;
